import styled from 'styled-components';

/** Who applied, shown above the answers they gave. */
/**
 * The reason of a decision. It is uncontrolled on purpose: the modal around it
 * rebuilds its content on every render of the screen, so keeping the value in
 * the DOM is what lets the field survive typing.
 */
export const ReasonInput = styled.textarea`
  width: 100%;
  min-height: 96px;
  margin-top: 8px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => (theme && theme.colors && theme.colors.gray[300]) || '#d5d5d5'};
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
`;

/** Label of the reason field inside the confirmation modal. */
export const ReasonLabel = styled.span`
  display: block;
  font-size: 14px;
  text-align: left;
`;
